import React from "react";
import "./achievementdetails.css";

function AchievementDetails() {
  return (
    <div className="achievement-details flex items-center justify-center py-10">
      <div className="container flex flex-col items-center justify-center">
        <p className="px-2 text-center py-2 text-2xl font-extrabold text-transparent text-3xl bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600">
          What our management say about it, real facts
        </p>
        <p className="text-center px-2 my-4">
          Our achievements has been contributed by both the organization and the
          society as well. We thank the public for you genuine trust on us.
          Thanks also to the government who have been funding the hospital
          outpatient programs such as the medical camps. The environs have also
          been set well for and security has been well checked. A big thank you
          also to our medical staffs who have been working tirelessly to make
          sure that health is well given to all. Some have subjected themselves
          to further studies to advance their knowledge so that they may be more
          effective in giving their services to the public.
        </p>
      </div>
    </div>
  );
}

export default AchievementDetails;
